module.exports = __webpack_public_path__ + "static/media/sfl_2.8d84726f.jpg";